import React from 'react';
import DataGrid from '@dataGrid';
import GridConfig from './GridConfig';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from './GridHeader';
import PrintReturnShipments from '../Print/PrintTable';
import { csvFormulaInjectionSanitizer } from '../../../../../../utilities/csvUtils';

class ReturnShipmentGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quickFilterText: '',
      printData: [],
    };
    this.printRef = React.createRef(null);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  getFilteredGridData = () => {
    const filteredData = [];
    this.gridApi.forEachNodeAfterFilter((node) =>
      filteredData.push(node.data)
    );
    return filteredData;
  };

  handleBeforeGetContentPrint = () => {
    return new Promise((resolve) => {
      this.setState({
        printData: this.getFilteredGridData(),
      }, () => resolve())
    });
  }

  handleAfterPrint = () => {
    this.setState({
      printData: [],
    })
  }

  setPrintRef = (compRef) => {
    this.printRef = compRef;
  }

  exportCSV = () => {
    if (!this.isDataAvailableForPrint()) {
      return;
    }
    const columnIds = this.gridApi.getColumns().reduce((columnKeys, column) => {
      if (column.colDef.headerName) {
        columnKeys.push(column.colId);
      }
      return columnKeys;
    }, []);
    const params = {
      fileName: "Return_Shipments",
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value),
    };
    this.gridApi.exportDataAsCsv(params);
  };

  isDataAvailableForPrint = () => {
    if (!this.props.returnShipments.length || !this.gridApi) {
      this.props.enqueueSnackbar("No data to download", {
        variant: "error",
      });
      return false;
    }
    return true;
  }

  updateQuickFilterText = (searchText) => {
    this.setState({
      quickFilterText: searchText
    });
  };

  constructStatusBar = (filteredData) => {
    const statusBarData = [
      {
        label: filteredData.length + " Returns",
        filterCondition: "",
      },
    ];
    return statusBarData;
  };

  render() {
    const { returnShipments = [], classes, onCloseModel, userProfile } = this.props;
    return (
      <>
        <div className={classes.container} id="return-shipments">
          <GridHeader
            exportCSV={this.exportCSV}
            title="Return Shipments"
            updateQuickFilterText={this.updateQuickFilterText}
            showPrint
            printRef={this.printRef}
            onBeforeGetContent={this.handleBeforeGetContentPrint}
            onAfterPrint={this.handleAfterPrint}
            onCloseModel={onCloseModel}
            gridApi={this.gridApi}
          />
          <div className={classes.dataGrid}>
            <DataGrid
              defaultColDef={this.gridConfig.config.defaultColDef}
              columnDefs={this.gridConfig.config.columns}
              config={this.gridConfig.config}
              rowData={returnShipments}
              onSelectionChanged={this.onSelectionChanged}
              panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
              quickFilterText={this.state.quickFilterText}
              onGridReady={this.onGridReady}
              showErrorMessage={this.props.gridErrorMessage}
            />
          </div>
        </div>
        <div className={classes.hideContainer}>
          <PrintReturnShipments
            title="Return Shipments"
            totalReturnShipments={this.gridApi?.getDisplayedRowCount?.() ?? 0}
            terminalOffset={userProfile.terminal.offset}
            terminalCode={userProfile.terminal.code}
            setPrintRef={this.setPrintRef} 
            printData={this.state.printData}
          />
        </div>
      </>
    );
  }
}
export default compose(withSnackbar, withStyles(styles))(ReturnShipmentGrid);
